module.exports = __webpack_public_path__ + "static/img/p-20.24e2f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-20.png
// module id = DyeI
// module chunks = 0